import { render } from "./ModalIncidence_categories.vue?vue&type=template&id=194be66c"
import script from "./ModalIncidence_categories.vue?vue&type=script&lang=js"
export * from "./ModalIncidence_categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__